/*
 * @Author: sipeng
 * @LastEditTime: 2022-09-08 16:21:02
 * @Description:
 * @LastEditors: Please set LastEditors
 */
export default {
  searchForTheAttributeRuleName: 'Search for The Attribute Rule Name',
  attributeRules: 'Attribute Rules',
  rulesName: 'Name',
  propertiesFile: 'Properties File',
  ruleBreakdown: 'Rule Breakdown',
  propertiesFileField: 'Properties File Field',
  propertyTemplateCode: 'Property Template Code',
  thePropertyTemplateName: 'The Property Template Name',
  propertyCode: 'Property Code',
  propertyName: 'Property Name',
  attributeCategory: 'Attribute Category',
  addedAttributeRules: 'Added Attribute Rules',
  editTheAttributeRule: 'Edit The Attribute Rule',
  addedAttributeRuleDetails: 'Added Attribute Rule Details',
  editTheAttributeRuleDetails: 'Edit The Attribute Rule Details',
  pleaseFillInThisField: 'Please Fill in This Field',
  pleaseSelectTheDataYouWantToDelete: 'Please Select The Data You Want to Delete',
  whetherToDeleteTheData: 'Whether to Delete The Data',
  deletionSuccessful: 'Deletion Successful!',
  pleaseSelectThePropertyTemplateCode: 'Please Select The Property Template Code!',
  pleaseSelectAPropertyCode: 'Please Select a Property Code!',
  thAttributeRuleHasNotBeenSelected: 'The Attribute Rule Has Not Been Selected',
}
